// Cola de certificación del catálogo (§11): lo que publica un autor fuera del equipo no se puede instalar hasta
// que alguien de Glubi lo revise. Vive en el panel interno desde la Fase 4, que es donde el equipo opera.
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Button, Cargando, Input, Tabla, Tag, Vacio } from '@glubi/ds';
import { api, mensajeDeError } from '../lib/api';
import { momento } from '../lib/formato';
import { useSesion } from '../lib/sesion';

export function ColaDeCertificacion() {
  const qc = useQueryClient();
  const { aviso } = useSesion();
  const cola = useQuery({ queryKey: ['certificacion'], queryFn: () => api<any[]>('/api/certificacion') });
  const [nota, setNota] = useState<Record<string, string>>({});
  const m = useMutation({
    mutationFn: ({ id, decision, nota: n }: { id: string; decision: string; nota?: string }) => api(`/api/certificacion/${id}`, { cuerpo: { decision, nota: n || undefined } }),
    onSuccess: () => { aviso('Revisada. Queda registrado quién decidió.'); void qc.invalidateQueries(); },
    onError: (e) => aviso(mensajeDeError(e)),
  });
  if (cola.isLoading) return <Cargando />;
  if (!cola.data?.length) return <Vacio titulo="Nada por certificar">Lo que publique un autor fuera del equipo llega acá antes de quedar instalable.</Vacio>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {cola.data.map((v) => (
        <div key={v.id} className="card" style={{ padding: 18 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <div>
              <Tag tone="amber">En revisión</Tag>
              <h3 style={{ margin: '8px 0 4px' }}>{v.nombre} · v{v.version}</h3>
              <div className="muted" style={{ fontSize: 13 }}>{v.resumen}</div>
            </div>
            <div className="muted" style={{ fontSize: 12 }}>Publicó {v.publicada_por?.nombre}<br />{momento(v.publicada_en)}</div>
          </div>
          <div className="card" style={{ padding: '10px 14px', margin: '12px 0', fontSize: 13, lineHeight: '19px' }}>{v.cambios}</div>
          <Tabla rowKey="clave" rows={(v.definicion?.reglas ?? []).map((r: any) => ({ clave: r.clave, etiqueta: r.etiqueta, tipo: r.tipo === 'calculo' ? 'Cálculo' : 'Revisión', detalle: r.partes ? r.partes.map((p: any) => `${p.etiqueta}: ${p.expresion}`).join(' · ') : (r.expresion ?? r.mensaje) }))}
            columns={[
              { key: 'etiqueta', label: 'Regla', render: (r: any) => <strong>{r.etiqueta}</strong> },
              { key: 'tipo', label: 'Tipo' },
              { key: 'detalle', label: 'Cómo se calcula', render: (r: any) => <code style={{ fontSize: 12 }}>{r.detalle}</code> },
            ]} />
          <div style={{ marginTop: 12 }}>
            <Input label="Nota de la revisión" value={nota[v.id] ?? ''} onChange={(e) => setNota({ ...nota, [v.id]: e.target.value })} helper="Rechazar pide decir por qué" />
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Button icon="check" onClick={() => m.mutate({ id: v.id, decision: 'certificada', nota: nota[v.id] })} disabled={m.isPending}>Certificar</Button>
            <Button variant="secondary" onClick={() => m.mutate({ id: v.id, decision: 'comunidad', nota: nota[v.id] })} disabled={m.isPending}>Publicar como comunidad</Button>
            <Button variant="ghost" onClick={() => m.mutate({ id: v.id, decision: 'rechazada', nota: nota[v.id] })} disabled={m.isPending || (nota[v.id] ?? '').trim().length < 3}>Rechazar</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
